import AddWarehouseRequest from "@/models/server/requests/AddWarehouseRequest";

export default class SaveWarehouseRequest extends AddWarehouseRequest {
    public warehouseId: string = "";
}